<?xml version="1.0" encoding="UTF-8"?>
<svg width="18" height="18" version="1.1" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">
 <path id="plus_icon" d="m15 10h-5v5h-2v-5h-5v-2h5v-5h2v5h5z" fill-rule="evenodd"/>
</svg>
